import React from 'react';
import Router from './router/Router';
import useKakaoLoader from './utils/useKakaoLoader';
import { Spinner } from './component/Spinner';

function App() {
  useKakaoLoader();

  return (
    <>
      <Router />
      <Spinner />
    </>
  );
}

export default App;
